import YFormLocaled from './Localed';

export { YFormLocaled };
export default YFormLocaled;
